import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Mail, MapPin } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer({ onOpenCookies }) {
  const { t } = useTranslation();
  const { lang: langParam } = useParams();
  const lang = langParam === "en" ? "en" : "ar";
  const base = `/${lang}`;

  return (
    <footer className="bg-[#0d1117] text-[#f6f0e2] mt-24">
      <div className="zv-container py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Logo variant="light" />
            <p className="mt-6 text-[15px] leading-relaxed text-white/70 max-w-xs">
              {t("footer.about")}
            </p>
            <p className="mt-6 text-[12px] text-white/50">
              {t("footer.risk_note")}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="zv-mono-tag text-white/60 mb-4">{t("footer.nav_title")}</div>
            <ul className="space-y-3 text-[15px]">
              <li><a href={`${base}`} className="zv-underline">{t("nav.home")}</a></li>
              <li><a href={`${base}#how`} className="zv-underline">{t("nav.how")}</a></li>
              <li><a href={`${base}#projects`} className="zv-underline">{t("nav.projects")}</a></li>
              <li><a href={`${base}#values`} className="zv-underline">{t("nav.about")}</a></li>
              <li><a href={`${base}#contact`} className="zv-underline">{t("nav.contact")}</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="zv-mono-tag text-white/60 mb-4">{t("footer.legal_nav_title")}</div>
            <ul className="space-y-3 text-[15px]">
              <li><Link to={`${base}/privacy`} className="zv-underline">{t("nav.privacy")}</Link></li>
              <li><Link to={`${base}/cookies`} className="zv-underline">{t("nav.cookies")}</Link></li>
              <li><Link to={`${base}/terms`} className="zv-underline">{t("nav.terms")}</Link></li>
              <li>
                <button onClick={onOpenCookies} className="zv-underline text-left">
                  {t("cookies_page.open_prefs")}
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="zv-mono-tag text-white/60 mb-4">{t("footer.contact_title")}</div>
            <ul className="space-y-3 text-[15px]">
              <li className="flex items-start gap-2">
                <Mail size={16} className="mt-1 shrink-0" />
                <a href="mailto:hola@zantravora.com" className="zv-underline">{t("footer.contact_email")}</a>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="mt-1 shrink-0" />
                <a href="mailto:prensa@zantravora.com" className="zv-underline">{t("footer.contact_press")}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-10 border-t border-white/10 pt-10">
          <div className="md:col-span-5">
            <div className="zv-mono-tag text-white/60 mb-4">{t("footer.legal_title")}</div>
            <ul className="text-[14px] text-white/80 space-y-1">
              <li>{t("footer.legal.company")}</li>
              <li>{t("footer.legal.reg")}</li>
              <li>{t("footer.legal.tax")}</li>
              <li>{t("footer.legal.license")}</li>
              <li>{t("footer.legal.jurisdiction")}</li>
              <li>{t("footer.legal.since")}</li>
            </ul>
          </div>
          <div className="md:col-span-7">
            <div className="zv-mono-tag text-white/60 mb-4">{t("footer.addresses_title")}</div>
            <ul className="text-[14px] text-white/80 space-y-3">
              <li className="flex items-start gap-2"><MapPin size={16} className="mt-1 shrink-0" />{t("footer.address_1")}</li>
              <li className="flex items-start gap-2"><MapPin size={16} className="mt-1 shrink-0" />{t("footer.address_2")}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-[12px] text-white/50">
          <div>{t("footer.rights")}</div>
          <div>zantravora.com</div>
        </div>
      </div>
    </footer>
  );
}
